import type { ReactNode } from 'react';
import { HIDDEN_BALANCES_FULL_TEXT } from '@/shared/config';
import { formatBalance } from '@/shared/lib';
import type { AccountRow } from '../model/useAccountRows';

type Props = {
  row: AccountRow;
  currency: string;
  precision: number;
  isBalancesHidden: boolean;
  title?: string;
  children?: ReactNode;
};

const AccountRowContent = ({
  row,
  currency,
  precision,
  isBalancesHidden,
  title,
  children,
}: Props) => (
  <span className="flex w-full min-w-0 items-center gap-[0.8rem]">
    {title ? (
      <span className="flex flex-1 min-w-0 items-center gap-[0.2rem] medium5 text-primary">
        <span className="shrink-0">{title}</span>
        <span className="truncate">{row.tradingAccKey}</span>
      </span>
    ) : (
      <>
        <span className="size-[2rem] rounded-full bg-secondary-bg overflow-hidden shrink-0">
          {row.iconUrl && (
            <img
              src={row.iconUrl}
              alt={row.assetCode}
              className="size-full object-cover"
            />
          )}
        </span>

        <span className="flex flex-1 min-w-0 items-center gap-[0.4rem]">
          <span className="medium5 text-primary whitespace-nowrap">
            {row.assetCode}
          </span>

          {row.leverage != null && (
            <span className="p4 text-secondary truncate">{row.leverage}x</span>
          )}
        </span>
      </>
    )}

    <span className="p6 text-secondary whitespace-nowrap">
      {isBalancesHidden
        ? `${HIDDEN_BALANCES_FULL_TEXT} ${currency}`
        : `${formatBalance(row.balance, precision)} ${currency}`}
    </span>

    {children}
  </span>
);

export { AccountRowContent };
